import tracker from '../TrackingService';

export const reportEvent = (additionalFields = {}) => {
    tracker.sendMixPanelEvent({
        eventName: Events.viewedReviews.Mixpanel,
        eventPayload: additionalFields,
    });
};

export const Events = {
    viewedReviews: {
        Mixpanel: 'Viewed Reviews Section',
    },
};
